import { isFacade } from '@tunasong/models'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { StyledEntityAvatar, StyledListItem, StyledListItemText } from './list-item.styles.js'
import { ListItemAvatar } from '../primitives/index.js'

/** Facade for a inaccessible item */
interface EntityListItemFacadeProps extends RenderMenuItemProps {
  disabled?: boolean
  ref: React.Ref<HTMLDivElement>
}
export const EntityListItemFacade: FC<EntityListItemFacadeProps> = props => {
  const { element, size, ref, className, onClick } = props

  if (!isFacade(element)) {
    return null
  }

  return (
    <StyledListItem className={className} onClick={onClick as never} ref={ref}>
      <ListItemAvatar>
        <StyledEntityAvatar type={element.type} size={size} />
      </ListItemAvatar>

      <StyledListItemText primary={element.description} secondary={element.id} />
    </StyledListItem>
  )
}

export default EntityListItemFacade
